import http from "./http-common";

const moduleList = {
  CAT_DASHBOARD: [
    "WEB_DASH_001", //Ticket Summary
    "WEB_DASH_002", //Agent KPI
  ],
  CAT_ACCESS_MGMT: [
    "WEB_USR_001", //Users
    "WEB_USR_002", //Roles
    "WEB_USR_003", //Permissions
  ],
  CAT_MASTER_DATA: [
    "WEB_MAS_001", //Policy
    "WEB_MAS_002", //Organization
    "WEB_MAS_003", //System
    "WEB_MAS_004", //Ticket Category
    "WEB_MAS_005", //Ticket Priority
    "WEB_MAS_006", //Ticket Status 
    "WEB_MAS_007", //Server Environment
    "WEB_MAS_008", //System Connection Type
  ],
  CAT_TICKET: [
    "WEB_TKT_001", //Ticket List
    "WEB_TKT_002", //View Ticket
    "WEB_TKT_003", //New Ticket
    "WEB_TKT_004", //standby
  ],
  CAT_SYSTEM_INFO: [
    "WEB_SYSIN_001", //System Info
  ],
  CAT_REPORT: [
    "WEB_RPT_001", //Ticket List History
  ]
};

const moduleBinary = {
  0: 0b0000000000000001,
  1: 0b0000000000000010,
  2: 0b0000000000000100,
  3: 0b0000000000001000,
  4: 0b0000000000010000,
  5: 0b0000000000100000,
  6: 0b0000000001000000,
  7: 0b0000000010000000,
  8: 0b0000000100000000,
  9: 0b0000001000000000,
  10: 0b0000010000000000,
  11: 0b0000100000000000,
  12: 0b0001000000000000,
  13: 0b0010000000000000,
  14: 0b0100000000000000,
  15: 0b1000000000000000,
};

function GetModuleList(moduleId) {
  return moduleList[moduleId];
}

function GetUserPermissionFn(userId, moduleCat, moduleList) {
  let promise = new Promise(function (resolve, reject) {
    const listItems = [];
    let permission = 0b0000000000000000;
    try {
      http
        .get(
          `api/WebCommon/GetUserAuthority?_userId=${userId}&_moduleCat=${moduleCat}`,
          { timeout: 10000000 }
        )
        .then((response) => {
          if (response.data.length > 0) {
            response.data.forEach((data, counter) => {
              listItems.push({
                MODULE_ID: data.MODULE_ID,
              });
            });
            moduleList.forEach((m, i) => {
              var module = listItems.filter((d) => d.MODULE_ID === m);
              if (module.length > 0) {
                permission = permission | moduleBinary[i];
              }
            });
          }
          resolve(permission);
        })
        .catch((err) => {
          reject(`Error on getting user permission list.`);
        });
    } catch (err) {
      reject(`Error on getting user permission list.`);
    }
  });
  return promise;
}

function GetPagePermissionFn(userId, moduleId) {
  let promise = new Promise(function (resolve, reject) {
    var listItems = [];
    try {
      http
        .get(
          `api/WebCommon/GetPageAuthority?_userId=${userId}&_moduleId=${moduleId}`,
          { timeout: 100000 }
        )
        .then((response) => {
          if (response.data.length > 0) {
            response.data.forEach((data, counter) => {
              listItems = {
                ...listItems,
                [data.FEATURE_TYPE]: data.AUTHORIZED,
              };
            });
          }
          resolve(listItems);
        })
        .catch((err) => {
          reject(`Error on checking user authority on ${moduleId}.`);
        });
    } catch (err) {
      reject(`Error on checking user authority on ${moduleId}.`);
    }
  });
  return promise;
}

function GetTicketButtonPermissionFn(userId, moduleId) {
  let promise = new Promise(function (resolve, reject) {
    var listItems = [];
    try {
      http
        .get(
          `api/permission/GetTicketButtonPermission?_userId=${userId}&_moduleId=${moduleId}`,
          { timeout: 100000 }
        )
        .then((response) => {
          if (response.data.length > 0) {
            response.data.forEach((data, counter) => {
              listItems = {
                ...listItems,
                [data.FEATURE_DESC]: data.AUTHORIZED,
              };
            });
          }
          resolve(listItems);
        })
        .catch((err) => {
          reject(`Error on checking ticket button permission on ${moduleId}.`);
        });
    } catch (err) {
      reject(`Error on checking ticket button permission on ${moduleId}.`);
    }
  });
  return promise;
}

function GetSpecialPermissionFn(userId, moduleId) {
  let promise = new Promise(function (resolve, reject) {
    var listItems = [];
    try {
      http
        .get(
          `api/permission/GetSpecialPermission?_userId=${userId}&_moduleId=${moduleId}`,
          { timeout: 100000 }
        )
        .then((response) => {
          if (response.data.length > 0) {
            response.data.forEach((data, counter) => {
              listItems = {
                ...listItems,
                [data.FEATURE_DESC]: data.AUTHORIZED,
              };
            });
          }
          resolve(listItems);
        })
        .catch((err) => {
          reject(`Error on checking special permission on ${moduleId}.`);
        });
    } catch (err) {
      reject(`Error on checking special permission on ${moduleId}.`);
    }
  });
  return promise;
}

function GetModifyPermissionFn(userId, moduleId) {
  let promise = new Promise(function (resolve, reject) {
    var listItems = [];
    try {
      http
        .get(
          `api/permission/GetModifyPermission?_userId=${userId}&_moduleId=${moduleId}`,
          { timeout: 100000 }
        )
        .then((response) => {
          if (response.data.length > 0) {
            response.data.forEach((data, counter) => {
              listItems = {
                ...listItems,
                [data.FEATURE_DESC]: data.AUTHORIZED,
              };
            });
          }
          resolve(listItems);
        })
        .catch((err) => {
          reject(`Error on checking modify permission on ${moduleId}.`);
        });
    } catch (err) {
      reject(`Error on checking modify permission on ${moduleId}.`);
    }
  });
  return promise;
}

export {
  moduleBinary,
  GetModuleList,
  GetUserPermissionFn,
  GetPagePermissionFn,
  GetTicketButtonPermissionFn, 
  GetSpecialPermissionFn,
  GetModifyPermissionFn,
};
